import axios from "axios";

// 1. Учитываем Docker/Local окружение (уже проверено, работает)
const baseURL = import.meta.env.MODE === 'development'
    ? import.meta.env.VITE_API_URL_DEV
    : "/api";

const Api = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});

let isRefreshing = false;
let failedQueue: any[] = [];

/**
 * Оптимизированная очистка очереди (твоя первая правка)
 */
const processQueue = (error: any, token: string | null = null) => {
    const callbacks = failedQueue;
    failedQueue = [];
    callbacks.forEach(({ resolve, reject }) => {
        error ? reject(error) : resolve(token);
    });
};

// Интерцептор ЗАПРОСА
Api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Интерцептор ОТВЕТА
Api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // 2. ИСКЛЮЧЕНИЯ: Не рефрешим токен, если упал ЛОГИН или сама ПРОВЕРКА (избегаем 401 зацикливания)
        const isAuthRoute = originalRequest.url.includes('/auth/login') ||
            originalRequest.url.includes('/auth/check');

        if (error.response?.status === 401 && !originalRequest._isRetry && !isAuthRoute) {

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        return Api.request(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._isRetry = true;
            isRefreshing = true;

            return new Promise((resolve, reject) => {
                // Используем чистый axios, чтобы не зациклить интерцептор
                axios.get(`${baseURL}/auth/check`, { withCredentials: true } as any)
                    .then(({ data }) => {
                        const newToken = data.accessToken;
                        localStorage.setItem("token", newToken);
                        originalRequest.headers.Authorization = `Bearer ${newToken}`;

                        processQueue(null, newToken);
                        resolve(Api.request(originalRequest));
                    })
                    .catch((err) => {
                        processQueue(err, null);
                        localStorage.removeItem("token");
                        reject(err);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }

        return Promise.reject(error);
    }
);

export default Api;
